import {
  any, boolean, date, nullable,
  number, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicUserMask = {
  boughtTicket: boolean,
  createdAt: date,
  emailHash: string,
  firstName: string,
  fullName: string,
  hasArtist: boolean,
  hasVenue: boolean,
  lastName: string,
  numShows: number,
  privateUpdatedAt: date | nullable,
  publicImageUrl: any | nullable,
  updatedAt: date,
  hasConnection: boolean,
};
